'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgArrowResizeDiagonalLeft = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "m6.124 6.124-.566 6.505 1.846 1.846.572-6.498 6.499-.573-1.846-1.846-6.505.566Zm3.401 10.472 1.845 1.846 6.506-.566.566-6.505-1.846-1.846-.573 6.498-6.498.573Z" })
);

module.exports = SvgArrowResizeDiagonalLeft;
//# sourceMappingURL=ArrowResizeDiagonalLeft.cjs.js.map
